import { useEffect } from 'react';

const Home = () => {
  useEffect(() => {
    const navbar = document.getElementById('navbar');
    const footer = document.getElementById('footer');
    navbar.style.display = 'none';
    footer.style.display = 'none';
  }, []);
  return (
    <iframe
      src="/azarakhshsolar.html"
      title="landing"
      style={{ display: 'block', width: '100%', height: '100dvh', border: 0 }}
    />
  );
};
export default Home;
